document.addEventListener('DOMContentLoaded', function () {
   
    const languageList = document.getElementById('HeaderLanguageList');
    const languageListFooter = document.getElementById('FooterLanguageList');

    if (languageList || languageListFooter) {
       
        const newLanguageItem = document.createElement('li');
        newLanguageItem.classList.add('disclosure__item');
        newLanguageItem.setAttribute('tabindex', '-1');

       
        newLanguageItem.innerHTML = `
            <a class="link link--text disclosure__link caption-large focus-inset" href="https://www.spacerebels.pl" target="_blank" rel="noopener noreferrer" data-value="custom">
                <span class="visibility-hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
                        <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path>
                    </svg>
                </span>
                <span>
                    Polski
                </span>
            </a>
            <a class="link link--text disclosure__link caption-large focus-inset" href="https://www.spacerebels.de" target="_blank" rel="noopener noreferrer" data-value="custom">
                <span class="visibility-hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
                        <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path>
                    </svg>
                </span>
                <span>
                    Deutsch
                </span>
            </a>
            <a class="link link--text disclosure__link caption-large focus-inset" href="https://www.spacerebels.es" target="_blank" rel="noopener noreferrer" data-value="custom">
                <span class="visibility-hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
                        <path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path>
                    </svg>
                </span>
                <span>
                    Español
                </span>
            </a>
        `;

        
        languageList.appendChild(newLanguageItem);
        languageListFooter.appendChild(newLanguageItem);
    }
});